import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';

interface EarnState {
  currentRangeId: string;
  setCurrentRangeId: (rangeId: string) => void;
}

export const useEarnStore = create<EarnState>()(
  devtools(
    persist(
      (set) => ({
        currentRangeId: '',
        setCurrentRangeId: (rangeId: string) => set(() => ({ currentRangeId: rangeId })),
      }),
      {
        name: 'earn-store',
      },
    ),
    {
      name: 'earn-store',
    },
  ),
);
